import { apiRequest } from "./client";
import { EarnedSticker } from "./sessions";

// A sticker in the child's book — the catalog entry plus whether this child
// has earned it.
export type StickerView = EarnedSticker & {
  earned: boolean;
  earnedAt: string | null;
};

export type AwardsResponse = {
  earnedCount: number;
  totalCount: number;
  stickers: StickerView[];
};

export const awardsApi = {
  // The child's full sticker book: every catalog sticker + earned flag.
  list: (childId: string, token: string): Promise<AwardsResponse> =>
    apiRequest<AwardsResponse>(`/v1/children/${childId}/awards`, { token }),
};
